export default __webpack_public_path__ + "static/media/cf.2e184db6.jpg";